import React, { Component } from "react";
import PropTypes from "prop-types";
import logoPartner from "../../assets/LogoGeralAquapark.png";
import "../../styling/home/home-header.css";

const propTypes = {
  // Function called after the search button is pressed
  didSearchText: PropTypes.func.isRequired,
};

class HomeHeader extends Component {
  render() {
    return (
      <div>
        <div class="container mb-4">
          <div class="row pt-4 pb-4" style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
            <img src={logoPartner} style={{ width: "290px" }} alt="Logo"/>
            <a href="http://aquaparkmardeminas.com.br/home.php"><h3 style={{color:'#C75000', fontWeight: '600'}}>Voltar</h3></a>
          </div>
          <div class="row">

          </div>
        </div>
        <div class="container mb-4 mt-4">
          <div class="row">
            <div class="col text-center" style={{backgroundColor:'#f15822', padding: '15px', color: 'white'}}>
              <h2 style={{ color: "white", fontWeight: '400' }}>Compre seu ingresso!</h2>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

HomeHeader.propTypes = propTypes;

export default HomeHeader;



// WEBPACK FOOTER //
// ./src/component/home/home-header.js